/**
 * UI-only primary label for an address hash (overrides wrong name tags / ENS).
 * Prefer token/contract names from verification when the indexer shows stale labels (e.g. WKPG9).
 */
const ADDRESS_PRIMARY_LABEL: Record<string, string> = {
  '0xc430ff0cf04b49de8269b5262bc2da8e73a54323': 'WDSC',
};

export function getAddressDisplayNameOverride(addressHash: string | null | undefined): string | undefined {
  if (!addressHash) {
    return undefined;
  }
  return ADDRESS_PRIMARY_LABEL[addressHash.toLowerCase()];
}
